import { Injectable } from "@angular/core";
import * as introJs from "intro.js/intro.js";
import { Global } from "../../global";

@Injectable({
  providedIn: "root",
})
export class IntroService {
  private steps = [];
  private stepsAdded = 0;
  private totalSteps = 6; // Total steps across all components

  constructor(public globals: Global) {}

  addSteps(newSteps) {
    this.steps = [...this.steps, ...newSteps];
    this.stepsAdded += newSteps.length;

    // Start Intro.js when all steps are added
    if (this.stepsAdded === this.totalSteps) {
      this.showIntroIfFirstTime();
    }
  }

  showIntroIfFirstTime() {
    const userGUID = this.getCurrentUserGUID();
    const introShownKey = `introShown_${userGUID}`;
    
    const introShown = localStorage.getItem(introShownKey);

    if (!introShown) {
      this.startIntro();
      localStorage.setItem(introShownKey, "true");
    }
  }

  startIntro() {
    this.steps.sort((a, b) => a.order - b.order);
    introJs()
      .setOptions({
        steps: this.steps,
        showProgress: true,
        tooltipClass: "customTooltip",
      })
      .start();
  }

  getCurrentUserGUID(): string {
    return this.globals.XRSUser.GUID;
  }
}
